import find from 'lodash/find'
import store from '../../store'
import analytics from '../cdpAnalytics'

export function sendRepoPageEvent(repoId) {
  const state = store.getState()
  const repo = find(state.repos, { id: repoId })

  if (repo) {
    let sharedType = 'private'
    if (repo.published) {
      sharedType = 'public'
    } else if (repo.shared) {
      sharedType = 'shared'
    }
    let permissionRole = 'pending'
    if (repo.disabled) {
      permissionRole = 'disabled'
    } else if (repo.joined) {
      permissionRole = repo.role
    } else if (repo.published) {
      permissionRole = repo.role
    }
    let hasImage = false
    if (repo.image !== '') {
      hasImage = true
    }
    const repoName = repo.name
    const repoDescription = repo.description

    analytics.track('Repo', {
      repoId,
      sharedType,
      permissionRole,
      hasImage,
      name: repoName,
      description: repoDescription,
      isFollowing: repo.following,

    })
  }
}
